/**
 * BOOT SCENE - Escena de Carga Inicial
 * Carga todos los assets y prepara el juego
 */

import Phaser from "phaser";
import { SCENES } from "../utils/constants.js";

export default class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: SCENES.BOOT });
  }

  // SNIPPET PARA BootScene.js
  // REEMPLAZAR TODO EL MÉTODO preload()

  preload() {
    // Mostrar barra de carga
    this.createLoadingBar();

    console.log("🌿 Mala Hierba - Cargando assets...");

    // ========================================
    // CARGAR CASAS POR RONDA (8 archivos)
    // ========================================

    // Ronda 1 - Siglo XVIX (Adobe Colonial)
    this.load.image(
      "casa_adobe_buena",
      "src/assets/images/houses/casa_adobe_buena.png"
    );
    this.load.image(
      "casa_adobe_mala",
      "src/assets/images/houses/casa_adobe_mala.png"
    );

    // Ronda 2 - 1970 (Caribbean)
    this.load.image(
      "casa_caribbean_buena",
      "src/assets/images/houses/casa_caribbean_buena.png"
    );
    this.load.image(
      "casa_caribbean_mala",
      "src/assets/images/houses/casa_caribbean_mala.png"
    );

    // Ronda 3 - 2026-2030 (Art Decó) ← Comentario actualizado
    this.load.image(
      "casa_artdeco_buena",
      "src/assets/images/houses/casa_artdeco_buena.png"
    );
    this.load.image(
      "casa_artdeco_mala",
      "src/assets/images/houses/casa_artdeco_mala.png"
    );

    // Ronda 4 - 2038-2042 (Modernismo) ← Comentario actualizado
    this.load.image(
      "casa_modernismo_buena",
      "src/assets/images/houses/casa_modernismo_buena.png"
    );
    this.load.image(
      "casa_modernismo_mala",
      "src/assets/images/houses/casa_modernismo_mala.png"
    );

    console.log("✅ 8 casas cargadas (4 rondas x 2 estados)");

    // ========================================
    // CARGAR GRIETAS (6 archivos)
    // ========================================

    for (let i = 1; i <= 6; i++) {
      const num = String(i).padStart(2, "0"); // 01, 02, 03...
      this.load.image(
        `grieta_${num}`,
        `src/assets/images/damages/grieta_${num}.png`
      );
    }

    console.log("✅ 6 grietas cargadas");

    // ========================================
    // CARGAR VINES (5 archivos)
    // ========================================

    for (let i = 1; i <= 5; i++) {
      const num = String(i).padStart(2, "0"); // 01, 02, 03...
      this.load.image(
        `vine_${num}`,
        `src/assets/images/damages/vine_${num}.png`
      );
    }

    console.log("✅ 5 vines cargadas");

    // ========================================
    // CARGAR UI (1 archivo)
    // ========================================

    this.load.image("logo", "src/assets/images/ui/logo_mala_hierba_1.png");

    console.log("✅ Logo oficial cargado");

    // ========================================
    // CARGAR BACKGROUNDS POR RONDA (4 archivos)
    // ========================================

    for (let i = 1; i <= 4; i++) {
      this.load.image(
        `bg_round_${i}`,
        `src/assets/images/backgrounds/bg_round_${i}.jpg`
      );
    }

    console.log("✅ 4 backgrounds de juego cargados");

    // Backgrounds de victoria (1 por ronda)
    for (let i = 1; i <= 4; i++) {
      this.load.image(
        `bg_win_round_${i}`,
        `src/assets/images/backgrounds/bg_win_round_${i}.jpg`
      );
    }

    console.log("✅ 4 backgrounds de victoria cargados");

    // Background de victoria final y derrota
    this.load.image(
      "bg_victory",
      "src/assets/images/backgrounds/bg_victory.jpg"
    );
    this.load.image("bg_lose", "src/assets/images/backgrounds/bg_lose.jpg");

    console.log("✅ Backgrounds de victoria final y derrota cargados");

    // Background de menú/home
    this.load.image("bg_home", "src/assets/images/backgrounds/bg_home.jpg");

    console.log("✅ Background de home cargado");

    // Overlay de derrota (figuras sin fondo)
    this.load.image(
      "defeat_overlay",
      "src/assets/images/backgrounds/bg_lose.png"
    );

    console.log("✅ Overlay de derrota cargado");

    // ========================================
    // 🎵 CARGAR AUDIO (NUEVO)
    // ========================================

    console.log("🎵 Cargando audio assets...");

    // Efectos de sonido (SFX)
    this.load.audio("clean", "src/assets/audio/sfx/clean.mp3");
    this.load.audio("cut", "src/assets/audio/sfx/cut.mp3");
    this.load.audio("win", "src/assets/audio/sfx/win.mp3");
    this.load.audio("lose", "src/assets/audio/sfx/lose.mp3");

    // Música
    this.load.audio("game_theme", "src/assets/audio/music/game_theme.mp3");
    this.load.audio(
      "final_victory",
      "src/assets/audio/music/final_victory.mp3"
    );

    console.log("✅ 6 archivos de audio cargados (4 SFX + 2 música)");

    // ========================================
    // RESUMEN
    // ========================================

    console.log("📦 Total assets: 38 archivos (32 imágenes + 6 audio)");
  }

  create() {
    console.log("✅ Assets cargados");

    // Ir directamente al menú principal
    this.scene.start(SCENES.MENU);
  }

  /**
   * Crear barra de carga visual
   */
  createLoadingBar() {
    const width = this.cameras.main.width;
    const height = this.cameras.main.height;

    // Texto de carga
    const loadingText = this.add.text(
      width / 2,
      height / 2 - 50,
      "CARGANDO...",
      {
        fontSize: "24px",
        color: "#ffffff",
        fontFamily: "Arial",
      }
    );
    loadingText.setOrigin(0.5);

    // Barra de progreso
    const progressBar = this.add.graphics();
    const progressBox = this.add.graphics();
    progressBox.fillStyle(0x222222, 0.8);
    progressBox.fillRect(width / 2 - 160, height / 2, 320, 50);

    // Actualizar barra de progreso
    this.load.on("progress", (value) => {
      progressBar.clear();
      progressBar.fillStyle(0x48bb78, 1);
      progressBar.fillRect(width / 2 - 150, height / 2 + 10, 300 * value, 30);
    });

    // Limpiar cuando termine
    this.load.on("complete", () => {
      progressBar.destroy();
      progressBox.destroy();
      loadingText.destroy();
    });
  }
}
